import {
    FiCreditCard,
    FiLayers,
    FiDollarSign,
    FiEdit2,
    FiSlash,
    FiCheckCircle,
} from "react-icons/fi";
import { formatCurrency } from "../../utils/formatCurrency";

export default function CuentaCard({ cuenta, onClick, onEdit, onInactivar, onActivar }) {
    const nombre = cuenta.nombre;

    const tipo =
        cuenta.tipoCuentaNombre ||
        cuenta.nombreTipoCuenta ||
        cuenta.nombre_tipo_cuenta ||
        cuenta.tipo_cuenta_nombre ||
        cuenta.idTipoCuenta ||
        cuenta.id_tipo_cuenta;

    const moneda =
        cuenta.monedaCodigo ||
        cuenta.moneda_codigo ||
        cuenta.codigo_moneda ||
        "PEN";

    const saldo =
        cuenta.saldoActual ??
        cuenta.saldo_actual ??
        cuenta.saldo ??
        0;

    const activa = String(cuenta.estado) === "1";

    return (
        <div className="cuenta-card" onClick={() => onClick(cuenta)}>
            <div className="cuenta-card-top">
                <h3 style={{ display: "flex", alignItems: "center", gap: 8, margin: 0 }}>
                    <FiCreditCard size={20} />
                    {nombre}
                </h3>
            </div>

            <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FiLayers size={16} />
                <strong>Tipo:</strong> {tipo}
            </p>

            <p style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <FiDollarSign size={16} />
                <strong>Moneda:</strong> {moneda}
            </p>

            <p
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 22,
                    fontWeight: 700,
                    marginBottom: 14,
                }}
            >
                <FiDollarSign size={18} />
                <strong>Saldo:</strong> {formatCurrency(saldo, moneda)}
            </p>

            <div
                className="cuenta-card-actions"
                onClick={(e) => e.stopPropagation()}
            >
                <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => onEdit(cuenta)}
                >
                    <FiEdit2 size={16} />
                    Editar
                </button>

                {activa ? (
                    <button
                        className="btn-danger"
                        type="button"
                        onClick={() => onInactivar(cuenta)}
                    >
                        <FiSlash size={16} />
                        Inactivar
                    </button>
                ) : (
                    <button
                        className="btn-primary"
                        type="button"
                        onClick={() => onActivar(cuenta)}
                    >
                        <FiCheckCircle size={16} />
                        Activar
                    </button>
                )}
            </div>
        </div>
    );
}